import { HowToPlaySceneBase } from "src/games/shared/scenes/HowToPlaySceneBase";
import { Games } from "src/constants/Games";
import { MainScene } from "./MainScene";
import { GameIntroScene } from "./GameIntro";

export class HowToPlayScene extends HowToPlaySceneBase {
    constructor() {
        super();
        this.gameRef = Games.Zoo;
        this.mainScene = MainScene;
        this.gameIntroScene = GameIntroScene;
        this.gameObjectiveTextKey = "Zoo.Phaser.HowToPlay.objectiveText";
        this.howToPlayOnComputerTextKey = "Zoo.Phaser.HowToPlay.computerInstructions";
        this.howToPlayOnTabletTextKey = "";
    }
}



// WEBPACK FOOTER //
// ./src/games/ZooGame/scenes/IntroductionScene.ts